import * as brazeSDK from '@braze/web-sdk';
import Cookies from 'js-cookie';
export var braze = brazeSDK;
export function setup() {
  try {
    braze.initialize('79863083-159f-477b-9c6b-8a17df04ab27', {
      baseUrl: 'sdk.fra-02.braze.eu'
    });
    braze.automaticallyShowInAppMessages();
    var brazeId = Cookies.get('braze_id');

    if (brazeId) {
      braze.changeUser(brazeId);
    }

    braze.openSession();
  } catch (e) {
    console.error(e);
  }
}